import { Spin } from "antd";

export const LoadingPage = () => {
  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <Spin spinning size="large" />
    </div>
  );
};
